import { render, staticRenderFns } from "./OnboardingContainer.vue?vue&type=template&id=068a791e&scoped=true&"
import script from "./OnboardingContainer.vue?vue&type=script&lang=js&"
export * from "./OnboardingContainer.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingContainer.vue?vue&type=style&index=0&id=068a791e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a791e",
  null
  
)

export default component.exports